import { render } from "./Table.vue?vue&type=template&id=783f90ce"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=783f90ce&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "783f90ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('783f90ce', script)) {
    api.reload('783f90ce', script)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=783f90ce", () => {
    api.rerender('783f90ce', render)
  })

}

script.__file = "src/components/Table.vue"

export default script